/* Clubvinted Handpick: aplica la regla (mínimo 2 prendas y no mezclar con balas)
   en la ventanita "Añadido a tu bolsa" y en cualquier enlace directo al pago. */
(function () {
  if (window.hpMiniLoaded) return;
  window.hpMiniLoaded = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var state = null;

  function message(d) {
    if (d.reason === 'mix') {
      return 'Las prendas Handpick se envían desde Madrid y van en un pedido aparte. Quita las balas o las prendas Handpick para poder pagar.';
    }
    var faltan = 2 - d.hp;
    return 'Pedido mínimo Handpick: 2 prendas. Llevas ' + d.hp + '. Te ' + (faltan === 1 ? 'falta 1 prenda' : 'faltan ' + faltan + ' prendas') + ' para poder pagar.';
  }

  function applyToMini() {
    var mini = document.querySelector('.cv-mini');
    if (!mini || !state) return;
    var go = mini.querySelector('.cv-mini-go');
    if (!go) return;
    var warn = mini.querySelector('.cv-mini-hp');
    if (state.block) {
      go.style.display = 'none';
      if (!warn) {
        warn = document.createElement('p');
        warn.className = 'cv-mini-warn cv-mini-hp';
        go.parentNode.insertBefore(warn, go);
      }
      warn.textContent = message(state);
    } else if (warn) {
      warn.remove();
      if (!mini.querySelector('.cv-mini-warn')) go.style.display = '';
    }
  }

  function check() {
    return fetch(root + 'cart?view=handpick', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        state = JSON.parse(t.trim());
        applyToMini();
        setTimeout(applyToMini, 150);
        setTimeout(applyToMini, 500);
      })
      .catch(function () {});
  }

  /* En la página Handpick no se abre la ventanita al añadir: solo se mete en el carrito */
  if (/\/collections\/clubvinted-handpick/.test(location.pathname)) {
    window.cvNoMini = true;
  }

  var css = document.createElement('style');
  css.textContent = '.hp-card__button--added{opacity:1!important;background:#e4ede3!important;color:#183228!important;border-color:#e4ede3!important;cursor:default}';
  document.head.appendChild(css);

  /* Marca como "En tu carrito" las prendas que ya están añadidas */
  function markAdded(cart) {
    if (!cart || !cart.items) return;
    var ids = {};
    cart.items.forEach(function (it) { ids[String(it.variant_id)] = true; });
    document.querySelectorAll('form[id^="HandpickAdd-"]').forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      var btn = form.querySelector('button[name="add"]');
      if (!input || !btn) return;
      if (ids[String(input.value)]) {
        if (btn.dataset.hpAdded) return;
        btn.dataset.hpAdded = '1';
        btn.setAttribute('disabled', '');
        btn.classList.add('hp-card__button--added');
        btn.innerHTML = '✓ En tu carrito';
      } else if (btn.dataset.hpAdded) {
        delete btn.dataset.hpAdded;
        btn.removeAttribute('disabled');
        btn.classList.remove('hp-card__button--added');
        btn.innerHTML = 'Añadir al carrito';
      }
    });
  }

  /* clubvinted.js lanza este evento cada vez que cambia el carrito */
  window.addEventListener('cv:cart', function (e) {
    markAdded(e.detail);
    check();
  });

  /* Cualquier enlace o botón que vaya directo a /checkout pasa antes por la comprobación */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/checkout"]');
    if (!a) return;
    e.preventDefault();
    var dest = a.href;
    check().then(function () {
      window.location.href = state && state.block ? root + 'cart' : dest;
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
